import {listCustomerOffersSearchSchema} from "@project/application/sales/customer-offers";
import type {z} from "zod";

export const offerHistorySearchSchema = listCustomerOffersSearchSchema.pick({
  page: true,
  perPage: true,
});
export type OfferHistorySearch = z.infer<typeof offerHistorySearchSchema>;
